export default __webpack_public_path__ + "tile-waddle.fb64f5d5.glb";